import { Link } from 'react-router';

import { Button } from 'DesignSystem/ui/button';

type Props = {
  to: string;
  children: React.ReactNode;
};

export default function TableLink({ to, children }: Props) {
  if (!children) return <>–</>;
  return (
    <Button variant="link" asChild size="text">
      <Link className="max-w-full font-m" to={to}>
        {children}
      </Link>
    </Button>
  );
}
